import androidx.compose.runtime.*
import kotlinx.browser.document
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlin.math.max
import kotlin.math.min

@Composable
fun <DataType> PagedList(pageSize: Int, data: List<DataType>, elementProducer: @Composable (DataType) -> Unit) {
    var currentPage by remember { mutableStateOf(1) }
    val numPages = max(1, data.size / pageSize + if (data.size % pageSize == 0) 0 else 1)
    if (currentPage > numPages) {
        currentPage = numPages
    }
    Div({ style {
        backgroundColor(Color.white)
        color(Color.gray)
        margin(5.px)
    }}) {
        Text("This website uses trademarks and/or copyrights owned by Paizo Inc., used under Paizo's Community Use Policy (paizo.com/communityuse). We are expressly prohibited from charging you to use or access this content. This website is not published, endorsed, or specifically approved by Paizo. For more information about Paizo Inc. and Paizo products, visit paizo.com.")
    }
    Div {
        B { Text("${data.size} results") }
    }
    PageSelector(numPages, currentPage) { currentPage = it }
    Div {
        val start = (currentPage - 1) * pageSize
        val end = min(data.size, start + pageSize)
        Page(data.subList(start, end), elementProducer)
    }
    PageSelector(numPages, currentPage) { currentPage = it; document.getElementById("pageTop")?.scrollIntoView() }
}

@Composable
fun PageSelector(numPages: Int, currentPage: Int, onChange: (Int) -> Unit) {
    if (numPages <= 1) {
        return
    }
    val start = max(currentPage - 2, 1)
    val end = min(start + 5, numPages)
    Div({ id("pageTop") }) {
        Span({ style { fontWeight("bold") } }) {
            Text("Page: ")
        }
        if (currentPage != 1) {
            GotoPage(currentPage - 1, onChange, "<")
        }
        if (start > 1) {
            GotoPage(1, onChange)
            if (start > 2)
                Text("...")
        }
        for (i in start..end) {
            if (i == currentPage) {
                Text(i.toString())
            } else {
                GotoPage(i, onChange)
            }
        }
        if (end < numPages) {
            if (end < numPages - 1)
                Text("...")
            GotoPage(numPages, onChange)
        }
        if (currentPage < numPages) {
            GotoPage(currentPage + 1, onChange, ">")
        }
    }
}

@Composable
fun GotoPage(target: Int, onChange: (Int) -> Unit, text: String = target.toString()) {
    Button({ style { myButtonStyle() }; onClick { onChange(target) } }) { Text(text) }
}

@Composable
fun <DataType> Page(data: Iterable<DataType>, elementProducer: @Composable (DataType) -> Unit) {
    for (i in data) {
        Div {
            elementProducer(i)
        }
    }
}